import { render } from "./CVSoftware.vue?vue&type=template&id=73a50812&scoped=true"
import script from "./CVSoftware.vue?vue&type=script&lang=js"
export * from "./CVSoftware.vue?vue&type=script&lang=js"

import "./CVSoftware.vue?vue&type=style&index=0&id=73a50812&scoped=true&lang=css"
import "./CVSoftware.vue?vue&type=style&index=1&id=73a50812&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73a50812"]])

export default __exports__